import { render, staticRenderFns } from "./OrganizationSelect.vue?vue&type=template&id=c11577e4&scoped=true&"
import script from "./OrganizationSelect.vue?vue&type=script&lang=js&"
export * from "./OrganizationSelect.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationSelect.vue?vue&type=style&index=0&id=c11577e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11577e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
